import React from 'react';
import amandaHarknessImg from './assets/amanda_harkness.jpg';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Main Content Container */}
      <div className="container mx-auto px-8 py-12 flex-1 flex flex-col">
        
        {/* Large RESEDA Title */}
        <div className="text-center mb-16">
          <h1 className="text-8xl md:text-9xl font-black text-gray-900 tracking-tight leading-none">
            Amanda Harkness
          </h1>
        </div>

        {/* Content Section */}
        <div className="grid lg:grid-cols-2 gap-12 items-stretch flex-1">
          
          {/* Left Side - Image */}
          <div className="relative">
            <div className="aspect-[4/5] bg-gray-200 rounded-sm overflow-hidden shadow-lg h-full">
              {/* Actual photography image */}
              <img 
                src={amandaHarknessImg} 
                alt="Amanda Harkness Photography" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Side - Text Content */}
          <div className="flex flex-col justify-end h-full">
            
            {/* Description Text */}
            <div className="w-full">
              <p className="text-gray-700 text-sm leading-relaxed max-w-md mb-4 courier-prime">
                Amanda Harkness is co-editor of Architecture NZ magazine, a contributor to
                ArchitectureNow and convenor of the annual Interior Awards programme.
              </p>
              <p className="text-gray-700 text-sm leading-relaxed max-w-md mb-4 courier-prime">
                She has worked in the architecture industry since 2018 and has formed strong relationships
                with both architects and suppliers/manufacturers, as well as academics and industry bodies.
              </p>
              <p className="text-gray-700 text-sm leading-relaxed max-w-md mb-4 courier-prime">
                Prior to working within the industry, Amanda held positions in magazine publishing,
                advertising, television and PR.
              </p>
              <p className="text-gray-700 text-sm leading-relaxed max-w-md mb-8 courier-prime">
                amanda@writeit.co.nz              
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;